<script setup lang="ts">
import SchoolHistory from '~/components/school/SchoolHistory.vue'
import SchoolVision from '~/components/school/SchoolVision.vue'
import SchoolPedagogy from '~/components/school/SchoolPedagogy.vue'
import SchoolTeam from '~/components/school/SchoolTeam.vue'
import SchoolValues from '~/components/school/SchoolValues.vue'
import SchoolPromoVideo from '~/components/school/SchoolPromoVideo.vue'
import AppCertifications from '~/components/ui/AppCertifications.vue'

const { setPageSeo } = useSeo()

await setPageSeo({
  title: "L'École de jeu vidéo",
  description: "OXO, école de jeu vidéo à Narbonne : une école à taille humaine où la passion du jeu vidéo se transmet au quotidien, en petit comité."
})

const { getAll: getAllVideos } = useSiteVideos()
const { data: siteVideos } = await useAsyncData('site-videos', () => getAllVideos())
const sectionVideoUrl = computed(() => siteVideos.value?.find(v => v.location === 'school-section')?.videoUrl || '')
</script>

<template>
  <div class="bg-background text-foreground min-h-screen transition-colors duration-300">
    <UiPageHero
      pageKey="school"
      image="/img/school-hero.png"
      badge-text="Découvrir l'école"
      titlePrefix="UNE AVENTURE"
      titleHighlight="HUMAINE"
      description="Bienvenue dans une école où la passion du jeu vidéo se transmet au quotidien, en petit comité."
      :tags="['ACCOMPAGNEMENT', 'PROXIMITÉ', 'ÉCHANGE']"
      height="screen"
      align="left"
      :primary-button="{ text: 'NOUS RENCONTRER', to: '/contact', umamiEvent: 'Ecole - Hero - Contact' }"
      :secondary-button="{ text: 'DÉCOUVRIR LES PROGRAMMES', to: '/formations', umamiEvent: 'Ecole - Hero - Formations' }"
    />

    <SchoolPromoVideo
      v-if="sectionVideoUrl"
      :video-url="sectionVideoUrl"
    />

    <SchoolVision />
    <SchoolValues />
    <SchoolPedagogy />

    <!-- Quality Section -->
    <section class="py-24 bg-background border-y border-oxo-border overflow-hidden">
      <div class="container mx-auto px-container-px">
        <div class="flex flex-col xl:flex-row items-center xl:items-center gap-12 xl:gap-20">
          <div class="xl:w-1/3 text-center xl:text-left">
            <UiSectionHeader 
              align="left"
              titlePrefix="NOTRE ENGAGEMENT"
              titleHighlight="QUALITÉ"
              subtitle="OXO s'engage dans une démarche d'amélioration continue pour offrir le meilleur accompagnement à ses étudiants."
              class="mb-0"
            />
          </div>
          <div class="w-full xl:w-2/3">
            <AppCertifications />
          </div>
        </div>
      </div>
    </section>

    <SchoolTeam />
    <SchoolHistory />
    <AppCTA
      title="Rejoignez"
      titleHighlight="L'AVENTURE"
      subtitle="Intégrez une école faite par des passionnés, pour des passionnés."
      buttonText="Candidater maintenant"
    />
  </div>
</template>

<style scoped>
/* Unified scroll experience */
</style>
